import { Api } from '../lib/api/api';
import { toast } from 'react-toastify';

export const getAllVmails = (token, paginateOptions, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALL_VMAILS',
  });
  try {
    const vmails = await api.vmails.getAllVmails(paginateOptions, dateFilter);
    dispatch({
      type: 'VMAILS_SUCCESS',
      vmails,
    });
  } catch (error) {
    dispatch({
      type: 'VMAILS_ERROR',
      error,
    });
  }
};

export const getVmailByCompany = (token, id, paginateOptions, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALL_VMAILS',
  });
  try {
    const vmails = await api.vmails.getVmailByCompany(id, paginateOptions, dateFilter);
    dispatch({
      type: 'VMAILS_SUCCESS',
      vmails,
    });
  } catch (error) {
    dispatch({
      type: 'VMAILS_ERROR',
      error,
    });
  }
};

export const getVmailsByUser = (token, id, paginateOptions, date) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALL_VMAILS',
  });
  try {
    const vmails = await api.vmails.getVmailsByUser(id, paginateOptions, date);
    dispatch({
      type: 'VMAILS_SUCCESS',
      vmails,
    });
  } catch (error) {
    dispatch({
      type: 'VMAILS_ERROR',
      error,
    });
  }
};

export const onRecover = (token, vmailId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_VAMIL',
  });
  try {
    await api.vmails.onRecover(vmailId);
    dispatch({
      type: 'RECOVER_VAMIL_SUCCESS',
    });
    toast.success('VMail Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_VAMIL_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering VMail`);
  }
};

export const deleteVMail = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_VMAIL',
    id,
  });
  try {
    const deletedVmail = await api.vmails.deleteVMail(id);
    dispatch({
      type: 'DELETE_VMAIL_SUCCESS',
      deletedVmail,
    });
    dispatch({
      type: 'DELETE_USER_CANCEL',
    });
    toast.success('Voice Mail deleted!');
    return deletedVmail;
  } catch (error) {
    dispatch({
      type: 'DELETE_VMAIL_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in deleting Voice Mail`);
  }
};

export const vmailPlayer = (token, id, type) => () => {
  const api = new Api();
  const res = api.vmails.vmailPlayer(token, id, type);
  return res;
};
